import { initAccordion } from "../../../../assets/js/accordion.js";

// Stappenplan: één stap tegelijk open. Zonder JS staan alle stappen open (de dichte stand zit alleen onder [data-steps-ready]).
document.querySelectorAll("[data-steps]").forEach((root) => {
	initAccordion({ root, item: ".step", toggle: ".step-toggle", panel: ".step-panel", openClass: "is-open", readyAttr: "data-steps-ready" });
});
